<template>
  <div class="p-2 h-screen">
    <div class="flex justify-between">
      <!-- Date Filter -->
      <div class="flex justify-between gap-1">
        <div
          class="flex justify-center items-center h-10 w-16 rounded-lg transition-all"
          :class="dateType === 'day' ? 'bg-yellow-500' : 'bg-gray-900'"
          @click="changeDateType('day')"
        >
          <span class="text-white">روز</span>
        </div>

        <div
          class="flex justify-center items-center h-10 w-16 rounded-lg transition-all"
          :class="dateType === 'month' ? 'bg-yellow-500' : 'bg-gray-900'"
          @click="changeDateType('month')"
        >
          <span class="text-white">ماه</span>
        </div>

        <div
          class="flex justify-center items-center h-10 w-16 rounded-lg transition-all"
          :class="dateType === 'year' ? 'bg-yellow-500' : 'bg-gray-900'"
          @click="changeDateType('year')"
        >
          <span class="text-white">سال</span>
        </div>
      </div>

      <!-- Type Filter -->
      <div class="flex justify-between gap-1">
        <div
          class="flex justify-center items-center h-10 w-16 rounded-lg transition-all"
          :class="numberType === 'qty' ? 'bg-yellow-500' : 'bg-gray-900'"
          @click="changeNumberType('qty')"
        >
          <span class="text-white">مقدار</span>
        </div>

        <div
          class="flex justify-center items-center h-10 w-16 rounded-lg transition-all"
          :class="numberType === 'mab' ? 'bg-yellow-500' : 'bg-gray-900'"
          @click="changeNumberType('mab')"
        >
          <span class="text-white">مبلغ</span>
        </div>
      </div>
    </div>

    <apexchart
      class="mt-4"
      height="95%"
      type="bar"
      :options="options"
      :series="series"
      @legendClick="handleClick"
    ></apexchart>
  </div>

  <div
    class="absolute flex items-center justify-center h-screen w-screen top-0 bg-gray-500/60"
    v-if="loading"
  >
    <LoadingSpinner class="h-14 w-14 text-yellow-500" />
  </div>
</template>

<script>
import { getNewFoodTypeReport } from "../../API/API";
import LoadingSpinner from "../General/LoadingSpinner";

export default {
  name: "MixedChart",
  components: { LoadingSpinner },
  data() {
    return {
      month: this.$route.query.month,
      dateType: "day",
      numberType: "qty",
      foodId1: this.$route.query.foodId1,
      foodId2: "",
      foodId3: "",
      reportType: this.$route.params.type,
      loading: true,
      options: {
        fontFamily: "iransans",
        colors: [
          "#ef4444",
          "#fb923c",
          "#9C27B0",
          "#3b82f6",
          "#22c55e",
          "#a855f7",
          "#ec4899",
          "#eab308",
        ],
        dataLabels: {
          enabled: true,
          formatter: (value) => {
            return this.$helper.numberShortener(value);
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        chart: {
          // type: 'bar',
          stacked: true,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              console.log(
                this.series[config.seriesIndex].ids[config.dataPointIndex]
              );
              this.changeFoodId(
                this.series[config.seriesIndex].ids[config.dataPointIndex]
              );
            },
          }
        },
        tooltip: {
          theme: "dark",
          y: {
            formatter: (value) => {
              return this.$helper.numberShortener(value);
            },
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on",
          labels: {
            style: {
              colors: "#d1d5db",
            },
            formatter: (value) => {
              return this.$helper.numberShortener(value);
            },
          },
        },
        yaxis: [
          {
            labels: {
              style: {
                colors: "#d1d5db",
              },
            },
          },
        ],
        grid: {
          borderColor: "#d1d5db",
        },
        legend: {
          position: "top",
          labels: {
            colors: "#fff",
          },
        },
      },
      series: [],
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    changeDateType(dateType) {
      this.dateType = dateType;
      this.getReport();
    },
    changeNumberType(numberType) {
      this.numberType = numberType;
      this.getReport();
    },
    changeFoodId(foodId) {
      if (this.foodId1 === "") {
        this.foodId1 = foodId;
      } else if (this.foodId2 === "") {
        this.foodId2 = foodId;
      } else if (this.foodId3 === "") {
        this.foodId3 = foodId;
      }
      this.getReport();
    },
    getReport() {
      this.loading = true;
      switch (this.reportType) {
        case "food":
          getNewFoodTypeReport(
            this.dateType,
            this.numberType,
            this.foodId1,
            this.foodId2,
            this.foodId3,
            "",
            this.dateType === "day" ? this.month : ""
          ).then((resp) => this.setChartData(resp));
          break;
      }
    },
    setChartData(resp) {
      // we have to update the whole options data, cant update nested props because ApexChart wont recognize the update
      this.options = {
        ...this.options,
        xaxis: {
          categories: resp.data.result.xaxis,
        },
      };
      this.series = resp.data.result.yaxis;
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
